import { render } from "./Unidades.vue?vue&type=template&id=1939c989&scoped=true"
import script from "./Unidades.vue?vue&type=script&lang=js"
export * from "./Unidades.vue?vue&type=script&lang=js"

import "./Unidades.vue?vue&type=style&index=0&id=1939c989&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1939c989"]])

export default __exports__